import '../../core/components/app-root/AppRoot.css';
import './PageLayout.css';
export var content = '_193kgwe3-3-5-0';
export var contentContainer = '_193kgwe2-3-5-0';
export var contentTopLeftRadius = '_193kgwe4-3-5-0';
export var contentTopRightRadius = '_193kgwe5-3-5-0';
export var headerContainer = '_193kgwe1-3-5-0';
export var layoutRoot = '_193kgwe0-3-5-0';